// 通过UA判断端类型
export var isMobile = function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 'ontouchstart' in document.documentElement || window.__cn_error_feedback_is_mobile;
};